import { React, useState, useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { CornerDownRight } from 'lucide-react';
import { Empty } from 'antd';
import { useParams } from 'react-router-dom';
import HistoryWorklog from '../Board/HistoryWorklog';

import {
  Box,
  Flex,
  Text,
  Badge,
  VStack,
  HStack,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Button,
} from '@chakra-ui/react';
import { FaEdit } from 'react-icons/fa';

import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';

import { DeleteIcon } from '@chakra-ui/icons';

import UserAvatar from 'components/userAvatar';
import { setassigneelist } from 'store/actions';
import { useDispatch } from 'react-redux';
import { getColorForUsername } from 'components/utils/AvatarColor';

import { Spinner } from 'reactstrap';

import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';

const Epicmodalactivity = ({ epicDetails, refreshKey }) => {
  const roleId = Number(Cookies.get('task-role-id'));
  const [isEditingComment, setIsEditingComment] = useState(false);
  const [comments, setComments] = useState([]);
  const [commentInput, setCommentInput] = useState('');
  const [replyInput, setReplyInput] = useState({});
  const [activeReply, setActiveReply] = useState(null);
  const [mentionSuggestions, setMentionSuggestions] = useState([]);
  const [activeReplyEditor, setActiveReplyEditor] = useState(null);
  const [editingText, setEditingText] = useState('');
  const [activeInputType, setActiveInputType] = useState(null);
  const { id: project_Id } = useParams();
  const { projectId, epicId } = useParams();
  const [tagSearch, setTagSearch] = useState('');
  const [showTagList, setShowTagList] = useState(false);
  const [activeInputId, setActiveInputId] = useState(null);
  const [originalText, setOriginalText] = useState('');

  const dispatch = useDispatch();

  const [taggedUsers, setTaggedUsers] = useState([]);
  const assigneeList = useSelector(
    (state) => state?.Authentication?.assigneelist,
  );

  const getEpiccomments = async () => {
    let reqbody = {
      project_id: projectId ? projectId : project_Id,
      epic_id: epicDetails.epic_id ? epicDetails.epic_id : epicId,
    };
    try {
      const res = await httpInjectorService.getEpicComments(reqbody);
      if (res.status === 'success') {
        setComments(res.data);
      } else {
        console.error('Failed to fetch comments:', res.message);
      }
    } catch (err) {
      console.error('Error fetching comments:', err);
    }
  };

  const getprojectAssignedEmployee = async () => {
    const ProjectId = projectId ? projectId : project_Id;

    try {
      let response =
        await httpInjectorService.getProjectAssignedEmployeelist(ProjectId);
      if (response.status === 'success') {
        // setAssignedEmployee(response.data);
        dispatch(setassigneelist(response.data));
      } else {
        dispatch(setassigneelist([]));
      }
    } catch (error) {
      console.error('Failed to fetch employee', error);
    }
  };

  const getInitials = (username) =>
    username
      .split(' ')
      .map((w) => w[0])
      .join('')
      .toUpperCase();

  const handleTagSelect = (user) => {
    let value;
    if (activeInputType === 'comment') value = commentInput;
    else if (activeInputType === 'reply') value = replyInput[activeInputId];
    else if (activeInputType === 'edit') value = editingText;

    const plainText = value.replace(/<[^>]+>/g, '');
    const updatedText = plainText
      .replace(/@\w*$/, `@${user.username} `)
      .replace(/\n/g, '<br>');

    // Update correct state
    if (activeInputType === 'comment') setCommentInput(updatedText);
    else if (activeInputType === 'reply')
      setReplyInput((prev) => ({ ...prev, [activeInputId]: updatedText }));
    else if (activeInputType === 'edit') setEditingText(updatedText);

    setTaggedUsers((prev) => [...prev, user]);

    setShowTagList(false);
  };

  const buildMentionRegex = () => {
    const names = assigneeList.map((u) => u.username.trim().toLowerCase());
    const escaped = names.map((n) => n.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    return new RegExp(`@(${escaped.join('|')})`, 'gi');
  };

  const htmlToText = (html) => {
    if (!html) return '';
    return html.replace(/<[^>]+>/g, '').trim();
  };

  const extractMentions = (htmlText) => {
    const plain = htmlToText(htmlText).toLowerCase();
    const regex = buildMentionRegex();

    const matches = [];
    let match;

    while ((match = regex.exec(plain)) !== null) {
      matches.push(match[1]); // username
    }

    return matches; // array of usernames exactly as stored
  };

  const handleMentionSelect = (user, type = 'comment', replyId = null) => {
    if (type === 'comment') {
      setCommentInput((prev) => prev + `@${user.username} `);
    } else if (type === 'reply') {
      setReplyInput((prev) => ({
        ...prev,
        [replyId]: (prev[replyId] || '') + `@${user.username} `,
      }));
      // Mark this user as tagged for this reply
      user.replyId = replyId;
    }

    setTaggedUsers((prev) => [...prev, user]);
    setMentionSuggestions([]);
  };

  useEffect(() => {
    getEpiccomments();
    getprojectAssignedEmployee();
  }, [projectId, project_Id]);

  const handleDeleteComment = async (commentId) => {
    try {
      const reqBody = {
        project_id: projectId ? projectId : project_Id,
        epic_id: epicDetails.epic_id ? epicDetails.epic_id : epicId,
        comment_id: commentId,
      };

      const res = await httpInjectorService.deleteEpicComment(reqBody);
      if (res.status === 'success') {
        toast.success('Comment deleted successfully');
        getEpiccomments();
      } else {
        toast.error(res.message || 'Failed to delete comment');
      }
    } catch (error) {
      toast.error('Something went wrong while deleting comment');
    }
  };

  const hexToRgb = (hex) => {
    if (!hex) return '';
    hex = hex.replace('#', '');

    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return `rgb(${r}, ${g}, ${b})`;
  };

  const postComment = async (text, parentId = null) => {
    const username = Cookies.get('username');

    // assigner avatar
    const assignerHex = getColorForUsername(username);
    const assignerRgb = hexToRgb(assignerHex);

    const taggedUsersArray = taggedUsers
      .filter((user) => text.includes(`@${user.username}`))
      .map((user) => {
        const userHex = getColorForUsername(user.username);
        const userRgb = hexToRgb(userHex);

        return {
          user_id: user.user_id,
          avatar_code: getInitials(user.username),
          avatar_color_code: userRgb,
        };
      });

    const requestBody = {
      project_id: projectId ? projectId : project_Id,
      epic_id: epicDetails.epic_id ? epicDetails.epic_id : epicId,
      comment_text: text,
      tagged_user_ids: taggedUsersArray,
      assigner_avatar: [
        {
          assigner_avatar_code: getInitials(username),
          assigner_avatar_color_code: assignerRgb,
        },
      ],
    };

    if (parentId) {
      requestBody.parent_comment_id = parentId;
    }

    try {
      const response = await httpInjectorService.addEpicComments(requestBody);

      if (response.status === 'success') {
        // Clear input(s)
        if (parentId) {
          setReplyInput((prev) => ({ ...prev, [parentId]: '' }));
          setActiveReply(null);
        } else {
          setCommentInput('');
        }

        setTaggedUsers([]);
        getEpiccomments();
      } else {
        console.error('Failed to post comment:', response.message || response);
      }
    } catch (err) {
      console.error('Error posting comment:', err);
    }
  };

  const handleOpenEdit = (comment) => {
    setEditingText(comment.comment_text); // current text in editor
    setOriginalText(comment.comment_text); // store original before editing
    setActiveReplyEditor(comment.comment_id);
  };

  const handleEditComment = async (commentId, updatedText) => {
    const oldMentions = extractMentions(originalText);
    const newMentions = extractMentions(updatedText);

    const addedMentions = newMentions.filter(
      (name) => !oldMentions.includes(name),
    );

    const username = Cookies.get('username');

    const assignerHex = getColorForUsername(username);
    const assignerRgb = hexToRgb(assignerHex);

    // 3️⃣ Build tagged user array ONLY for added users
    const taggedUsersArray = taggedUsers
      .filter((user) => addedMentions.includes(user.username))
      .map((user) => ({
        user_id: user.user_id,
        avatar_code: getInitials(user.username),
        avatar_color_code: hexToRgb(getColorForUsername(user.username)),
      }));

    try {
      const reqBody = {
        project_id: projectId ? projectId : project_Id,
        comment_id: commentId,
        comment_text: updatedText,
        tagged_user_ids: taggedUsersArray,
        assigner_avatar: [
          {
            assigner_avatar_code: getInitials(username),
            assigner_avatar_color_code: assignerRgb,
          },
        ],
      };

      const res = await httpInjectorService.editEpiccomment(reqBody);
      if (res.status === 'success') {
        toast.success('Comment updated successfully');
        getEpiccomments();
      } else {
        toast.error(res.message || 'Failed to update comment');
      }
    } catch (error) {
      toast.error('Something went wrong while updating comment');
    }
  };
  const handleTagTyping = (value, type, id = null) => {
    const plainText = value.replace(/<[^>]+>/g, '');

    // Update corresponding input state
    if (type === 'comment') setCommentInput(value);
    else if (type === 'reply')
      setReplyInput((prev) => ({ ...prev, [id]: value }));
    else if (type === 'edit') setEditingText(value);

    // Determine cursor word for '@'
    const words = plainText.split(/\s+/);
    const lastWord = words[words.length - 1] || '';

    if (lastWord.startsWith('@')) {
      setTagSearch(lastWord.substring(1));
      setShowTagList(true);
      setActiveInputType(type);
      setActiveInputId(id);
    } else {
      setShowTagList(false);
    }
  };

  const renderTagList = () => {
    if (!showTagList) return null;

    const filteredUsers = assigneeList.filter((u) =>
      u.username.toLowerCase().includes(tagSearch.toLowerCase()),
    );

    return (
      <Box
        position="absolute"
        bg="white"
        border="1px solid #d9d9d9"
        borderRadius="6px"
        mt={1}
        maxH="180px"
        overflowY="auto"
        zIndex={2000}
        width="200px"
      >
        {filteredUsers.map((user) => (
          <Flex
            key={user.user_id}
            px={3}
            py={2}
            cursor="pointer"
            _hover={{ bg: 'gray.100' }}
            onClick={() => handleTagSelect(user)}
          >
            <UserAvatar username={user.username} size={20} />
            <Text ml={2}>{user.username}</Text>
          </Flex>
        ))}
      </Box>
    );
  };

  return (
    <div>
      {' '}
      <Box marginTop={5}>
        <Tabs variant="unstyled" ml={5}>
          {/* 🔹 Tab Buttons */}
          <TabList
            width="fit-content"
            border="1px solid #e2e8f0"
            borderRadius="6px"
            p="2px"
            gap="2px"
          >
            <Tab
              fontSize="12px"
              px="8px"
              py="3px"
              _selected={{
                border: '1px solid #3182CE',
                color: '#3182CE',
                bg: 'white',
                borderRadius: '4px',
              }}
            >
              ALL
            </Tab>

            <Tab
              fontSize="12px"
              px="8px"
              py="3px"
              _selected={{
                border: '1px solid #3182CE',
                color: '#3182CE',
                bg: 'white',
                borderRadius: '4px',
              }}
            >
              Comments
            </Tab>

            <Tab
              fontSize="12px"
              px="8px"
              py="3px"
              _selected={{
                border: '1px solid #3182CE',
                color: '#3182CE',
                bg: 'white',
                borderRadius: '4px',
              }}
            >
              History
            </Tab>

            <Tab
              fontSize="12px"
              px="8px"
              py="3px"
              _selected={{
                border: '1px solid #3182CE',
                color: '#3182CE',
                bg: 'white',
                borderRadius: '4px',
              }}
            >
              Work log
            </Tab>
          </TabList>

          {/* 🔹 Tab Panels */}
          <TabPanels mt={4}>
            <TabPanel>
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No data available"
              />
            </TabPanel>

            <TabPanel>
              <TabPanel p={4}>
                {/* Comment Input - upgraded with rich text editor */}
                {[1, 2, 3].includes(roleId) && (
                  <Box mb={4}>
                    {!isEditingComment ? (
                      <Box
                        p={3}
                        border="1px solid #e2e8f0"
                        borderRadius="8px"
                        bg="white"
                        cursor="text"
                        minH="120px" // ✅ removed height="50px" (this was breaking layout)
                        onClick={() => setIsEditingComment(true)}
                      >
                        <Text color="gray.400" fontSize="sm">
                          Add a comment...
                        </Text>

                        {/* 👉 Suggestion Chips */}
                        <Box width="100%" mt={3} overflow="hidden">
                          <Flex
                            gap={2}
                            flexWrap="wrap"
                            width="100%"
                            minW={0}
                            alignItems="flex-start"
                          >
                            {[
                              '🎉 Looks good!',
                              '👋 Need help?',
                              '⛔ This is blocked...',
                              '🔍 Can you clarify...?',
                              '✅ This is on track',
                            ].map((s) => (
                              <Box
                                key={s}
                                px={2}
                                py={1}
                                fontSize="xs"
                                border="1px solid #e2e8f0"
                                borderRadius="6px"
                                cursor="pointer"
                                flex="0 1 auto" // ✅ allows wrapping & prevents overflow
                                minW={0} // ✅ critical for long chip text
                                maxW="100%"
                                whiteSpace="normal" // ✅ allow multi-line chips
                                wordBreak="break-word" // ✅ long words break safely
                                _hover={{ bg: 'gray.100' }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setCommentInput(s);
                                  setIsEditingComment(true);
                                }}
                              >
                                {s}
                              </Box>
                            ))}
                          </Flex>
                        </Box>
                      </Box>
                    ) : (
                      <Box minH="140px">
                        <ReactQuill
                          theme="snow"
                          value={commentInput}
                          onChange={(v) => handleTagTyping(v, 'comment')}
                          placeholder="Add a comment..."
                          modules={{
                            toolbar: [
                              ['bold', 'italic', 'underline', 'strike'],
                              [{ list: 'ordered' }, { list: 'bullet' }],
                              [{ color: [] }, { background: [] }],
                              ['link', 'image'],
                              ['clean'],
                            ],
                          }}
                          style={{
                            backgroundColor: 'white',
                            borderRadius: '8px',
                            minHeight: '100px',
                          }}
                        />
                        {renderTagList()}
                        <Flex justify="flex-start" mt={2}>
                          <Button
                            size="sm"
                            colorScheme="blue"
                            borderRadius="0px"
                            onClick={() => {
                              postComment(commentInput);
                              setIsEditingComment(false);
                            }}
                          >
                            save
                          </Button>
                          <Button
                            size="sm"
                            variant="ghost"
                            borderRadius="0px"
                            onClick={() => setIsEditingComment(false)}
                            ml={2}
                          >
                            Cancel
                          </Button>
                        </Flex>
                      </Box>
                    )}
                  </Box>
                )}

                {/* Mention Suggestions */}
                {mentionSuggestions.length > 0 && (
                  <Box
                    bg="white"
                    borderWidth="1px"
                    borderRadius="md"
                    maxH="150px"
                    overflowY="auto"
                    position="absolute"
                    bottom="100%"
                    mb={1}
                    zIndex="1"
                  >
                    {mentionSuggestions.map((user) => (
                      <HStack
                        key={user.user_id}
                        px={3}
                        py={2}
                        _hover={{ bg: 'gray.100', cursor: 'pointer' }}
                        onClick={() => handleMentionSelect(user)}
                        spacing={2}
                      >
                        <UserAvatar username={user.username} size={24} />
                        <Text>{user.username}</Text>
                      </HStack>
                    ))}
                  </Box>
                )}

                {/* List Comments and Replies */}
                <Box>
                  {comments.length > 0 ? (
                    comments.map((comment) => (
                      <Box
                        key={comment.comment_id}
                        mb={4}
                        p={2}
                        // borderWidth="1px"
                        // borderRadius="md"
                      >
                        {/* 🔹 Main Comment */}
                        <HStack align="start" spacing={3}>
                          {/* 🧑 Avatar */}
                          <UserAvatar username={comment.username} size={28} />

                          <Box flex="1">
                            {/* 👤 Username & Time */}
                            <Box lineHeight="1.1">
                              <Text
                                fontWeight="semibold"
                                fontSize="sm"
                                color="gray.700"
                                mb="1px" // reduced gap between username & time
                              >
                                {comment.username}
                              </Text>
                              <Text fontSize="xs" color="gray.500" mt="0">
                                {new Date(
                                  comment.edited_status === 1
                                    ? comment.updated_at
                                    : comment.created_at,
                                ).toLocaleString('en-IN', {
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true,
                                })}{' '}
                                {comment.edited_status === 1 && '(edited)'}
                              </Text>
                            </Box>

                            {/* ✏️ Editing Mode */}
                            {activeReplyEditor === comment.comment_id ? (
                              <Box mt={2}>
                                <ReactQuill
                                  theme="snow"
                                  value={editingText}
                                  onChange={(v) =>
                                    handleTagTyping(
                                      v,
                                      'edit',
                                      comment.comment_id,
                                    )
                                  }
                                  placeholder="Edit your comment..."
                                  modules={{
                                    toolbar: [
                                      ['bold', 'italic', 'underline', 'strike'],
                                      [{ list: 'ordered' }, { list: 'bullet' }],
                                      [{ color: [] }, { background: [] }],
                                      ['link', 'image'],
                                      ['clean'],
                                    ],
                                  }}
                                />
                                <Flex justify="flex-start" mt={2}>
                                  <Button
                                    size="sm"
                                    colorScheme="blue"
                                    borderRadius="0px"
                                    onClick={async () => {
                                      await handleEditComment(
                                        comment.comment_id,
                                        editingText,
                                      );
                                      setActiveReplyEditor(null);
                                    }}
                                  >
                                    save
                                  </Button>
                                  <Button
                                    size="sm"
                                    variant="ghost"
                                    borderRadius="0px"
                                    onClick={() => setActiveReplyEditor(null)}
                                    ml={2}
                                  >
                                    Cancel
                                  </Button>
                                </Flex>
                              </Box>
                            ) : (
                              <>
                                {/* 💬 Comment text */}
                                <Box
                                  fontSize="sm"
                                  mt={1}
                                  dangerouslySetInnerHTML={{
                                    __html: comment.comment_text,
                                  }}
                                />

                                {/* 🛠️ Actions */}
                                {[1, 2, 3].includes(roleId) && (
                                  <HStack spacing={1} mt={1}>
                                    <Button
                                      size="xs"
                                      variant="link"
                                      colorScheme="gray"
                                      onClick={() =>
                                        setActiveReply(
                                          activeReply === comment.comment_id
                                            ? null
                                            : comment.comment_id,
                                        )
                                      }
                                    >
                                      <CornerDownRight
                                        size={14}
                                        style={{
                                          marginRight: '6px',
                                          transform: 'rotate(180deg)',
                                        }}
                                      />
                                    </Button>
                                    <Button
                                      size="xs"
                                      variant="link"
                                      colorScheme="gray"
                                      onClick={() => {
                                        setActiveReplyEditor(
                                          comment.comment_id,
                                        );
                                        setEditingText(comment.comment_text);
                                      }}
                                    >
                                      <FaEdit
                                        style={{ marginRight: '4px' }}
                                        onClick={() => handleOpenEdit(comment)}
                                      />
                                    </Button>
                                    <Button
                                      size="xs"
                                      variant="link"
                                      colorScheme="gray"
                                      onClick={() =>
                                        handleDeleteComment(comment.comment_id)
                                      }
                                    >
                                      <DeleteIcon mr={1} />
                                    </Button>
                                  </HStack>
                                )}
                              </>
                            )}
                          </Box>
                        </HStack>

                        {/* 🔹 Replies */}
                        {comment.replies.length > 0 && (
                          <Box ml={8} mt={3} borderLeft="2px solid #ccc" pl={3}>
                            {comment.replies.map((reply) => (
                              <Box key={reply.comment_id} mb={3}>
                                <HStack align="start" spacing={3}>
                                  {/* 🧑 Avatar */}
                                  <UserAvatar
                                    username={reply.username}
                                    size={24}
                                  />

                                  <Box flex="1">
                                    {/* 👤 Username & Time */}
                                    <Box lineHeight="1.1">
                                      <Text
                                        fontWeight="semibold"
                                        fontSize="sm"
                                        color="gray.700"
                                        mb="1px"
                                      >
                                        {reply.username}
                                      </Text>
                                      <Text
                                        fontSize="xs"
                                        color="gray.500"
                                        mt="0"
                                      >
                                        {new Date(
                                          comment.edited_status === 1
                                            ? comment.updated_at
                                            : comment.created_at,
                                        ).toLocaleString('en-IN', {
                                          day: '2-digit',
                                          month: 'short',
                                          year: 'numeric',
                                          hour: '2-digit',
                                          minute: '2-digit',
                                          hour12: true,
                                        })}{' '}
                                        {reply.edited_status === 1 &&
                                          '(edited)'}
                                      </Text>
                                    </Box>

                                    {/* ✏️ Editing Mode for reply */}
                                    {activeReplyEditor === reply.comment_id ? (
                                      <Box mt={2}>
                                        <ReactQuill
                                          theme="snow"
                                          value={editingText}
                                          onChange={(v) =>
                                            handleTagTyping(
                                              v,
                                              'edit',
                                              reply.comment_id,
                                            )
                                          }
                                          placeholder="Edit your reply..."
                                          modules={{
                                            toolbar: [
                                              [
                                                'bold',
                                                'italic',
                                                'underline',
                                                'strike',
                                              ],
                                              [
                                                { list: 'ordered' },
                                                { list: 'bullet' },
                                              ],
                                              [
                                                { color: [] },
                                                { background: [] },
                                              ],
                                              ['link', 'image'],
                                              ['clean'],
                                            ],
                                          }}
                                        />
                                        {renderTagList()}
                                        <Flex justify="flex-start" mt={2}>
                                          <Button
                                            size="sm"
                                            colorScheme="blue"
                                            borderRadius="0px"
                                            onClick={async () => {
                                              await handleEditComment(
                                                reply.comment_id,
                                                editingText,
                                              );
                                              setActiveReplyEditor(null);
                                            }}
                                          >
                                            save
                                          </Button>
                                          <Button
                                            size="sm"
                                            variant="ghost"
                                            borderRadius="0px"
                                            onClick={() =>
                                              setActiveReplyEditor(null)
                                            }
                                            ml={2}
                                          >
                                            Cancel
                                          </Button>
                                        </Flex>
                                      </Box>
                                    ) : (
                                      <>
                                        {/* 💬 Reply text */}
                                        <Box
                                          fontSize="sm"
                                          mt={1}
                                          dangerouslySetInnerHTML={{
                                            __html: reply.comment_text,
                                          }}
                                        />

                                        {/* 🛠️ Actions */}
                                        {[1, 2, 3].includes(roleId) && (
                                          <HStack spacing={1} mt={1}>
                                            <Button
                                              size="xs"
                                              variant="link"
                                              colorScheme="gray"
                                              onClick={() =>
                                                setActiveReply(
                                                  activeReply ===
                                                    reply.comment_id
                                                    ? null
                                                    : reply.comment_id,
                                                )
                                              }
                                            >
                                              <CornerDownRight
                                                size={14}
                                                style={{
                                                  marginRight: '6px',
                                                  transform: 'rotate(180deg)',
                                                }}
                                              />
                                            </Button>
                                            <Button
                                              size="xs"
                                              variant="link"
                                              colorScheme="gray"
                                              onClick={() => {
                                                setActiveReplyEditor(
                                                  reply.comment_id,
                                                );
                                                setEditingText(
                                                  reply.comment_text,
                                                );
                                              }}
                                            >
                                              <FaEdit
                                                style={{
                                                  marginRight: '4px',
                                                }}
                                                onClick={() =>
                                                  handleOpenEdit(comment)
                                                }
                                              />
                                            </Button>
                                            <Button
                                              size="xs"
                                              variant="link"
                                              colorScheme="gray"
                                              onClick={() =>
                                                handleDeleteComment(
                                                  reply.comment_id,
                                                )
                                              }
                                            >
                                              <DeleteIcon mr={1} />
                                            </Button>
                                          </HStack>
                                        )}
                                      </>
                                    )}
                                  </Box>
                                </HStack>

                                {/* ✅ Reply input under this reply */}
                                {activeReply === reply.comment_id && (
                                  <Box mt={2} ml={8}>
                                    <ReactQuill
                                      theme="snow"
                                      value={replyInput[reply.comment_id] || ''}
                                      onChange={(v) =>
                                        handleTagTyping(
                                          v,
                                          'reply',
                                          reply.comment_id,
                                        )
                                      }
                                      placeholder="Write a reply..."
                                      modules={{
                                        toolbar: [
                                          [
                                            'bold',
                                            'italic',
                                            'underline',
                                            'strike',
                                          ],
                                          [
                                            { list: 'ordered' },
                                            { list: 'bullet' },
                                          ],
                                          [{ color: [] }, { background: [] }], // 🎨 Add color & highlight
                                          ['link', 'image', 'code-block'],
                                          ['clean'],
                                        ],
                                      }}
                                      style={{
                                        backgroundColor: 'white',
                                        borderRadius: '8px',
                                        minHeight: '80px',
                                      }}
                                    />
                                    {renderTagList()}
                                    <Flex justify="flex-start" mt={2}>
                                      <Button
                                        size="sm"
                                        colorScheme="blue"
                                        borderRadius="0px"
                                        onClick={() => {
                                          postComment(
                                            replyInput[reply.comment_id],
                                            reply.parent_comment_id,
                                          );
                                          setActiveReply(null);
                                        }}
                                      >
                                        save
                                      </Button>
                                      <Button
                                        size="sm"
                                        variant="ghost"
                                        borderRadius="0px"
                                        onClick={() => setActiveReply(null)}
                                        ml={2}
                                      >
                                        Cancel
                                      </Button>
                                    </Flex>
                                  </Box>
                                )}
                              </Box>
                            ))}
                          </Box>
                        )}

                        {/* ✅ Reply input for main comment */}
                        {activeReply === comment.comment_id && (
                          <Box mt={3} ml={8}>
                            <ReactQuill
                              theme="snow"
                              value={replyInput[comment.comment_id] || ''}
                              onChange={(v) =>
                                handleTagTyping(v, 'reply', comment.comment_id)
                              }
                              placeholder="Write a reply..."
                              modules={{
                                toolbar: [
                                  ['bold', 'italic', 'underline', 'strike'],
                                  [{ list: 'ordered' }, { list: 'bullet' }],
                                  [{ color: [] }, { background: [] }],
                                  ['link', 'image'],
                                  ['clean'],
                                ],
                              }}
                              style={{
                                backgroundColor: 'white',
                                borderRadius: '8px',
                                minHeight: '80px',
                              }}
                            />
                            {renderTagList()}
                            <Flex justify="flex-start" mt={2}>
                              <Button
                                size="sm"
                                colorScheme="blue"
                                borderRadius="0px"
                                onClick={() => {
                                  postComment(
                                    replyInput[comment.comment_id],
                                    comment.comment_id,
                                  );
                                  setActiveReply(null);
                                }}
                              >
                                save
                              </Button>
                              <Button
                                size="sm"
                                variant="ghost"
                                borderRadius="0px"
                                onClick={() => setActiveReply(null)}
                                ml={2}
                              >
                                Cancel
                              </Button>
                            </Flex>
                          </Box>
                        )}
                      </Box>
                    ))
                  ) : (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="No data available"
                    />
                  )}
                </Box>
              </TabPanel>
            </TabPanel>

            <TabPanel>
              {' '}
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No data available"
              />
            </TabPanel>

            <TabPanel>
              <HistoryWorklog taskdata={epicDetails} work_type={'EPIC'} refreshKey={refreshKey} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </div>
  );
};

export default Epicmodalactivity;
